// import accessTokenRequest from '@/utils/custom-axios';
import axios from "axios";

export const LabTestsServices = {
  submitLabTest(patientToken, payload) {
    return axios.post(
      `${process.env.VUE_APP_API}/diagnostics/orders`,
      payload,
      {
        headers: {
          Authorization: `Token ${patientToken}`,
        },
      },
    );
  },
};
